export interface OpenClaimResponse {
	openClaimResult: OpenClaimResult;
}

interface OpenClaimResult {
	error?: string;
	typeError?: string;
	codError?: string;
	auditoryInfo: AuditoryInfo;
	actuationId: string;
	claimId: string;
	edaCode: string;
	languageInfo?: Language[];
}

interface Language {
	moreInfoI: MoreInfoI[];
	languageDescField: string;
	languageId: string;
	error: string;
}

export interface MoreInfoI {
	code: string;
	priority: string;
	resolvingGroup: string[];
	type: string;
	value: string;
}

interface AuditoryInfo {
	originCall: string;
	transactionId: string;
}
